import { AddAssetCard } from '@/components/Cards/AddAssetCard';
import { CreateAvatarModal, useOpenCreateAvatarModal } from '@/pages/avatar';
import { useAgentEditorStore } from '@/state/root';
import { Presenter, PresenterUsecase } from '@d-id/types';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';

const StyledAddAssetCard = styled(AddAssetCard)`
    height: 100%;
    background-color: white;
    aspect-ratio: 16/9;
`;

const TriggerContainer = styled.div`
    background: ${({ theme }) => theme.colors.white};

    cursor: pointer;

    border-radius: 8px;
    border: ${({ theme }) => `1px solid ${theme.colors.black[300]};`};
    overflow: hidden;

    :hover {
        border: ${({ theme }) => `1px solid ${theme.colors.secondary[900]};`};
    }
`;

export const styles = {
    tooltip: {
        sx: {
            backgroundColor: 'white',
            padding: '16px',
            borderRadius: '14px',
            maxWidth: 'unset',
            boxShadow:
                '0.3px 0.8px 1.1px 0px rgba(187, 187, 187, 0.12), 1.1px 2.8px 3.9px -0.4px rgba(187, 187, 187, 0.17), 2.4px 6.1px 8.6px -0.8px rgba(187, 187, 187, 0.23), 5.3px 13.3px 18.8px -1.2px rgba(187, 187, 187, 0.29)',
        },
    },
};

export const AddAvatarCard = observer(() => {
    const agentEditorStore = useAgentEditorStore();

    const { pathname } = useLocation();

    const openCreateAvatarModal = useOpenCreateAvatarModal();

    const onClick = () => {
        openCreateAvatarModal({ from: pathname, useCase: PresenterUsecase.Agent });
    };

    const onAvatarUpload = async (avatar: Presenter | undefined) => {
        if (avatar) {
            agentEditorStore.setSelectedPresenter(avatar.id);
            agentEditorStore.resetPresenterBackgroundSourceUrl();
            agentEditorStore.resetPresenterBackgroundThumbnailUrl();
        }
    };

    return (
        <>
            <TriggerContainer>
                <StyledAddAssetCard onClick={onClick} label={'Create Avatar'} />
            </TriggerContainer>
            <CreateAvatarModal from="agents" onUpload={onAvatarUpload} />
        </>
    );
});
